document.addEventListener('DOMContentLoaded',()=>{
  const observer=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      if(entry.isIntersecting){
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  },{threshold:.12});

  document.querySelectorAll('.luma-reveal').forEach(element=>observer.observe(element));

  const projectSelect=document.querySelector('[data-luma-project-select]');
  if(projectSelect){
    const selectedProject=new URLSearchParams(location.search).get('project');
    if(selectedProject&&[...projectSelect.options].some(option=>option.value===selectedProject)){
      projectSelect.value=selectedProject;
    }
  }

  const mobileDrawer=document.querySelector('header-drawer');
  if(mobileDrawer){
    mobileDrawer.addEventListener('click',event=>{
      const summary=event.target.closest('.menu-drawer__navigation details > summary');
      if(!summary||!mobileDrawer.contains(summary))return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const details=summary.parentElement;
      const willOpen=!details.hasAttribute('open');

      if(willOpen){
        details.setAttribute('open','');
        details.classList.add('menu-opening');
      }else{
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      }

      summary.setAttribute('aria-expanded',String(willOpen));
    },true);
  }
});
